import { render } from "./DashboardStart.vue?vue&type=template&id=aaeb9d6a&scoped=true"
import script from "./DashboardStart.vue?vue&type=script&lang=js"
export * from "./DashboardStart.vue?vue&type=script&lang=js"

import "./DashboardStart.vue?vue&type=style&index=0&id=aaeb9d6a&scoped=true&lang=css"
import "./DashboardStart.vue?vue&type=style&index=1&id=aaeb9d6a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aaeb9d6a"]])

export default __exports__